import { useState, FC, memo } from 'react';
import { Icon } from 'semantic-ui-react';
import { useTranslation, WithTranslation, withTranslation } from 'react-i18next';
import React from 'react';
import { DateTimePeriod } from 'stores/events/events-store';
import { DateInput } from './dateInput';
import { DateTimeService } from 'services/datetime-service';
import { SemanticICONS } from 'semantic-ui-react/dist/commonjs/generic';

interface TailwindPeriodInputProps extends WithTranslation {
  readOnly?: boolean;
  clearable?: boolean;
  onChange: (period: DateTimePeriod) => void;
  value: DateTimePeriod;
  minMaxDate?: boolean;
  max?: string;
  yearRangeAvailable?: boolean;
  /** If FALSE won't be render an icon */
  icon?: SemanticICONS | false;
  iconPosition?: any;
  id?: string;
  min?: string;
  defaultStartDate?: string;
  defaultEndDate?: string;
}

const TailwindPeriodInput: FC<TailwindPeriodInputProps> = props => {
  const {
    readOnly,
    value,
    minMaxDate,
    yearRangeAvailable,
    icon,
    clearable,
    iconPosition,
    min,
    max,
    defaultStartDate,
    defaultEndDate
  } = props;
  const { t } = useTranslation();
  const [openPopup, setOpenPopup] = useState(() => !!value?.from || false);

  const handleFromDate = (date: string) => {
    const value = props.value ? { ...props.value } : { from: null, to: null };
    value.from = date;
    setOpenPopup(DateTimeService.isValid(date));
    props.onChange(value);
  };

  const handleToDate = (date: string) => {
    const value = props.value ? { ...props.value } : { from: null, to: null };
    value.to = date;
    setOpenPopup(false);
    props.onChange(value);
  };

  const fromMin =
    yearRangeAvailable && value?.to ? DateTimeService.toString(DateTimeService.toMoment(value.to).subtract(1, 'years')) : null;
  const toMax = yearRangeAvailable && value?.from ? DateTimeService.toString(DateTimeService.toMoment(value.from).add(1, 'years')) : null;
  return (
    <>
      <div className="required field mb-3 flex flex-col space-y-2">
        {/* <label className="block text-sm font-medium text-gray-700 mb-1">{t('From')}</label> */}
        <DateInput
          iconPosition={iconPosition}
          className="w-full p-2 border border-gray-300 rounded"
          readOnly={readOnly}
          value={value?.from || ''}
          initialValue={defaultStartDate ? defaultStartDate : null}
          onChange={(_, data) => handleFromDate(data)}
          maxDate={max || (minMaxDate && value?.to) || null}
          minDate={fromMin}
          icon={icon || null}
          placeholder={t('From')}
        />

        {/* <label className="block text-sm font-medium text-gray-700 mb-1">{t('to')}</label> */}
        <DateInput
          id={'period-to-' + props.id}
          iconPosition={iconPosition}
          className="w-full p-2 border border-gray-300 rounded"
          readOnly={readOnly}
          value={value?.to || ''}
          forceOpen={openPopup}
          initialValue={value?.from ? value?.from : defaultEndDate ? defaultEndDate : null}
          onChange={(_, data) => handleToDate(data)}
          minDate={min || (minMaxDate && value?.from) || null}
          maxDate={toMax}
          icon={icon || null}
          placeholder={t('To')}
        />
      </div>
      {clearable && !readOnly && (
        <Icon style={{ marginLeft: 8, cursor: 'pointer' }} color="red" size="large" name="times" onClick={() => props.onChange(null)} />
      )}
    </>
  );
};

export default withTranslation()(memo(TailwindPeriodInput));
